import { Union } from 'ts-toolbelt';

import { TsrctLink } from '@/generated/gql/graphql';

export interface ExternalLink {
  name: string;
  url: Union.Nullable<string>;
}

export interface DemandReference {
  purchaseRequisitionId?: Union.Nullable<string>;
  referenceId?: Union.Nullable<string>;
  links?: ExternalLink[];
}

export const filterInvalidLinks = (links?: Union.Nullable<ExternalLink[]>): TsrctLink[] => {
  return (links?.filter((p) => p.url) ?? []) as TsrctLink[];
};
